<script>
  import { present, style, blocklist, text, richtext, image, url } from "../toolbox.js";
  import { link } from "svelte-routing";

  export let block;
</script>

<!-- Section with four info areas left & one card right with image and waves -->
<section style="{style(block)}">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6">
        <div class="row align-items-center">
          {#each blocklist(block, 'features') as item}
          <div class="col-lg-6">
            <div class="info">
              <div class="icon icon-md text-center">
                <img src="{image(item, 'icon', [50, 50])}" alt="">
              </div>
              <h5 class="mt-3">{text(item, 'headline')}</h5>
              <p class="fs-5">{@html richtext(item, 'body')}</p>
            </div>
          </div>
          {/each}
        </div>
      </div>
      <div class="col-lg-4 ms-auto">
        <div class="card">
          <img class="card-img-top" src="{image(block, 'picture', ['_', 400])}">
          <div class="position-relative overflow-hidden" style="height:50px;margin-top:-50px;">
            <div class="position-absolute w-100 top-0 z-index-1">
                <svg class="waves waves-sm" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 24 150 40" preserveAspectRatio="none" shape-rendering="auto">
                  <defs>
                    <path id="card-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"></path>
                  </defs>
                  <g class="moving-waves">
                    <use xlink:href="#card-wave" x="48" y="-1" fill="rgba(255,255,255,0.30"></use>
                    <use xlink:href="#card-wave" x="48" y="3" fill="rgba(255,255,255,0.35)"></use>
                    <use xlink:href="#card-wave" x="48" y="5" fill="rgba(255,255,255,0.25)"></use>
                    <use xlink:href="#card-wave" x="48" y="8" fill="rgba(255,255,255,0.20)"></use>
                    <use xlink:href="#card-wave" x="48" y="13" fill="rgba(255,255,255,0.15)"></use>
                    <use xlink:href="#card-wave" x="48" y="16" fill="rgba(255,255,255,0.99)"></use>
                  </g>
                </svg>
              </div>
          </div>
          <div class="card-body">
            <h4>
              {text(block, 'headline')}
            </h4>
            <p class="fs-5">
              {@html richtext(block, 'body')}
            </p>
            {#if present(block, 'contact')}
            <a href="{url(block, 'link')}" class="icon-move-right">
              {text(block, 'link')}
              <i class="fas fa-arrow-right text-xs ms-1"></i>
            </a>
            {/if}
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- END Section with four info areas left & one card right with image and waves -->
